export const PRODUCER_ID_OLYMPIACOS = 2538;
export const PRODUCER_ID_KOK = 4420;
